module.exports = __webpack_public_path__ + "img/background035.9fd9ed5a.jpg";